import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { useLanguage } from "../../../../context/LanguageContext";

export default function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="flex flex-col items-center space-y-4 p-6 bg-white rounded-xl shadow-md">
      <div className="flex items-center space-x-2">
        <Globe className="w-5 h-5 text-gray-600" />
        <h3 className="text-lg font-medium">Language / Sprache</h3>
      </div>

      <div
        className="relative w-64 h-14 bg-gray-100 rounded-full p-1 cursor-pointer"
        onClick={toggleLanguage}
      >
        <motion.div
          className={`absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full shadow-md flex items-center justify-center font-medium text-white bg-orange-500`}
          initial={false}
          animate={{
            x: language === "en" ? "0%" : "100%",
          }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
        >
          {language === "en" ? "English" : "Deutsch"}
        </motion.div>

        <div className="relative z-10 h-full flex">
          <div
            className={`flex-1 flex items-center justify-center ${
              language === "en" ? "text-white" : "text-gray-400"
            }`}
          >
            English
          </div>
          <div
            className={`flex-1 flex items-center justify-center ${
              language === "de" ? "text-white" : "text-gray-400"
            }`}
          >
            Deutsch
          </div>
        </div>
      </div>

      <p className="text-sm text-gray-500 text-center">
        {language === "en"
          ? "Your preferred language is English"
          : "Ihre bevorzugte Sprache ist Deutsch"}
      </p>
    </div>
  );
}
